import { Component, signal, inject, OnInit, OnDestroy } from '@angular/core';
import { RouterOutlet, RouterModule, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { Firestore } from '@angular/fire/firestore';
import { AnalyticsService } from './services/analytics.service';
import { PromoStatusService } from './services/promo-status.service';
import { AppLoadingComponent } from './shared/components/app-loading/app-loading';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterModule, AppLoadingComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit, OnDestroy {
  protected readonly title = signal('crust-game-of-life');

  //TESTING ONLY
  private firestore = inject(Firestore);
  private router = inject(Router);
  private analyticsService = inject(AnalyticsService);
  private promoStatusService = inject(PromoStatusService);
  private routerSubscription?: Subscription;
  
  firebaseStatus = 'Testing...';
  environment = '';
  projectId = '';

  // Track promo status loading state
  isPromoStatusLoading = this.promoStatusService.isLoading;

  constructor() {
    this.testConnection();
  }

  ngOnInit(): void {
    // Track page views on route changes
    this.routerSubscription = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        this.analyticsService.trackPageView(event.urlAfterRedirects);
      });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  testConnection() {
    try {
      const app = this.firestore.app;
      this.projectId = app.options.projectId || 'Unknown';
      this.environment = this.projectId.includes('-dev') ? 'Development' : 'Production';
      this.firebaseStatus = 'Connected ✅';
    } catch (error) {
      this.firebaseStatus = 'Failed ❌';
      console.error('Firebase connection error:', error);
    }
  }

}